import type { ReactNode } from 'react'

interface Props {
  title: string
  description: string
  actions?: ReactNode
  headerActions?: ReactNode
  hideHeader?: boolean
  children: ReactNode
}

export default function ForgePane({ title, description, actions, headerActions, hideHeader = false, children }: Props) {
  return (
    <section className="flex h-full min-h-0 flex-col overflow-hidden bg-background">
      {!hideHeader && <header className="flex min-h-16 shrink-0 items-center gap-3 border-b border-border px-4 py-2.5">
        <div className="min-w-0 flex-1">
          <h2 className="truncate text-sm font-semibold text-foreground">{title}</h2>
          <p className="mt-0.5 truncate text-xs text-muted-foreground">{description}</p>
        </div>
        {actions}
        {headerActions}
      </header>}
      <div className="min-h-0 flex-1 overflow-hidden">{children}</div>
    </section>
  )
}
